var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6a9a23",
    d: "M102.586 11.777C115.99 21.862 125.476 36.285 128 53c1.77 20.765-2.116 38.348-15.758 54.59-11.177 12.014-25.888 20.006-42.441 20.746C49.54 128.669 33.193 124.134 18 110 4.47 96.18-.426 80.316-.366 61.39c.328-17.993 7.994-33.235 20.796-45.77 23.335-20.46 56.89-21.207 82.156-3.843M56 36v20H36v16h20v20h16V72h20V56H72V36z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlusIcon);
export default __webpack_public_path__ + "static/media/green-plus-icon.5ea8b32c1b42c2d0e4066c1929b19b2e.svg";
export { ForwardRef as ReactComponent };